import React, { useState, useEffect, useRef } from "react";
import clsx from "clsx";
import { isEmpty } from "../../utils/utils";
import PropTypes from "prop-types";

// import { clsx, isEmpty } from '@brokers-hr/utils';

/**
 * Input React Component
 * Example:
 * <Input label="Input" value={text} onChange={value => setText(value)} />
 */
const Input = ({
  onChange,
  onClick,
  onBlur,
  onkeydown,
  disabled,
  className,
  label,
  value,
  name,
  type,
  customRegex,
  maxLength,
  minLength,
  hasError, // ENVIAR UN TEXTO O COMPONENTE
  hasSpan, // ENVIAR UN TEXTO O COMPONENTE
  id,
  sufixHolder,
  sufixSolid,
  style,
  sufixHolderIcon,
  sufixIcon,
  msgTooltip,
  imgTooltip,
}) => {
  const refInput = useRef(null);
  const [active, setActive] = useState("");
  const [val, setVal] = useState(value ?? "");
  const IconHolder = sufixHolderIcon;

  const regexByTypeInput = {
    number: /[^0-9]/g,
    decimal: /^(\d{1,}|\d{1,}\.\d{0,2})$/,
    alphaNumeric: /[^a-z0-9]/gi,
    password: /[^a-z0-9_@./$#&+-]/gi,
    series: /^([a-z](\d|[a-z]){0,3})$/gi, // series - factura
  };

  useEffect(() => {
    if (val !== value) {
      setVal(value);
    }
  }, [value]);

  const handleChange = (e) => {
    if (!disabled && onChange) {
      let text = e.target.value;

      if (!isEmpty(customRegex)) {
        if (isEmpty(text) || customRegex.test(text)) {
          onChange(text);
          setVal(text);
        }
        return;
      }

      if (type === "decimal") {
        if (isEmpty(text) || regexByTypeInput.decimal.test(text)) {
          onChange(text);
          setVal(text);
        }

        return;
      } else if (type === "series") {
        if (isEmpty(text) || regexByTypeInput[type].test(text)) {
          onChange(text.toUpperCase());
          setVal(text.toUpperCase());
        }

        return;
      } else if (type !== "text") {
        text = text.replace(regexByTypeInput[type], "");
      }
      onChange(text);
      //setVal(text);
    }
  };

  const mouseDownEvt = (event) => {
    if (!refInput || refInput.current.contains(event.target)) {
      return;
    }

    setActive("");
  };

  useEffect(() => {
    document.addEventListener("mousedown", mouseDownEvt);
    return () => document.removeEventListener("mousedown", mouseDownEvt);
  }, []);

  const getInputProps = () => {
    let defaultPropsInput = {
      type: "text",
    };
    if (type === "password") {
      defaultPropsInput.type = "password";
    }
    if (type === "decimal") {
      defaultPropsInput.type = "text";
      defaultPropsInput.pattern = "d+";
      defaultPropsInput.step = "0.00";
      defaultPropsInput.inputMode = "decimal";
    }

    defaultPropsInput.autoComplete = "null";

    return defaultPropsInput;
  };

  return (
    <>
      <div
        id={id}
        ref={refInput}
        className={clsx("rd--input", active, className, {
          ["disabled"]: disabled,
          ["filled"]: !isEmpty(val),
          ["has-error"]: hasError,
          ["has-span"]: hasSpan,
          ["sufix--solid"]: sufixSolid,
        })}
        disabled={disabled}
        onClick={() => setActive("active")}
        style={style}
      >
        <label>{label}</label>
        <input
          name={name}
          maxLength={maxLength}
          minLength={minLength}
          value={val ?? ""}
          onChange={handleChange}
          onBlur={onBlur}
          onClick={onClick}
          onKeyDown={onkeydown}
          disabled={disabled}
          {...getInputProps()}
        />
        {sufixHolder && <span className="rd--input--sufix">{sufixHolder}</span>}
        {sufixHolderIcon && sufixIcon && (
          <div className="rd--input--tooltip">
            <IconHolder
              event="onClick"
              children={<img src={`${sufixIcon}`} />}
              message={msgTooltip}
              icon={imgTooltip}
            />
          </div>
        )}
      </div>
      {hasSpan && (
        <div className="rd--input-span" htmlFor={id}>
          {hasSpan}
        </div>
      )}
      {hasError && (
        <span className="rd--input-error" htmlFor={id}>
          {hasError}
        </span>
      )}
    </>
  );
};

Input.propTypes = {
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onBlur: PropTypes.func,
  onkeydown: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  customRegex: PropTypes.any,
  hasError: PropTypes.any,
  hasSpan: PropTypes.any,
  id: PropTypes.any,
  sufixHolder: PropTypes.any,
  sufixSolid: PropTypes.bool,
  style: PropTypes.object,
};

Input.defaultProps = {
  onChange: () => {},
  onClick: () => {},
  onBlur: () => {},
  onkeydown: ()=> {},
  disabled: false,
  className: "",
  label: "",
  value: "",
  name: "",
  type: "text",
  customRegex: null,
  hasError: null, // ENVIAR UN TEXTO O COMPONENTE
  hasSpan: null, // ENVIAR UN TEXTO O COMPONENTE
  id: null,
  sufixHolder: null,
  sufixSolid: false,
  style: {},
};

export default Input;
